import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { PageHeader, Empty } from "@/components/shared";
import { Input } from "@/components/ui/input";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/admin/audit-logs", { params: q ? { action: q } : {} }).then((r) => setLogs(r.data)); }, [q]);
  return (
    <div>
      <PageHeader title="Journal d'audit" subtitle="Toutes les actions sensibles : zpub, clés API, domaines, webhooks, rejets de domaine, actions admin.">
        <Input placeholder="Filtrer par action (ex : domain.rejected)" value={q} onChange={(e) => setQ(e.target.value)} className="w-72 font-mono text-xs" data-testid="audit-filter-input" />
      </PageHeader>
      {logs.length === 0 ? <Empty text="Aucune entrée." /> : (
        <div className="panel overflow-x-auto" data-testid="audit-logs-table">
          <table className="w-full text-sm">
            <thead className="text-left text-xs text-zinc-500 border-b border-border"><tr><th className="p-3">Date</th><th className="p-3">Action</th><th className="p-3">Marchand</th><th className="p-3">IP</th><th className="p-3">Détails</th></tr></thead>
            <tbody>{logs.map((l) => (
              <tr key={l.id} className="border-b border-border/60" data-testid="audit-log-row">
                <td className="p-3 text-xs text-zinc-500 whitespace-nowrap">{fmtDate(l.created_at)}</td>
                <td className="p-3 font-mono text-xs text-amber-400">{l.action}</td>
                <td className="p-3 font-mono text-[10px] text-zinc-500">{l.merchant_id?.slice(0, 8) || "—"}</td>
                <td className="p-3 font-mono text-xs text-zinc-400">{l.ip}</td>
                <td className="p-3 text-xs text-zinc-400 max-w-md truncate">{JSON.stringify(l.details)}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
